import type { FC } from 'react';
import { RecursionWrapper } from './Recursion.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';

interface RecursionProps {}

const Recursion: FC<RecursionProps> = () => (
 <RecursionWrapper>	
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Recursion</h1>			
   </header>
   <br/>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify"><strong>Recursion</strong>&nbsp;is a concept in which a method calls itself continuously. Any function which calls itself is recursive, and such function calls are recursive calls. It helps solve problems that can be broken down into smaller, repetitive problems provided one or more base conditions that stop the recursion.</p>
      <p className="text-align-justify"><strong>Advantages :</strong></p>
      <ul className="text-align-justify">
         <li>The code is simpler and shorter.</li>
         <li>More readable and efficient algorithms.</li>
         <li>Reduce time complexity.</li>
         <li>Better for tree and graph traversal.</li>
         <li>Avoid unnecessary repetitive blocks of code.</li>
      </ul>
   
      <p className="text-align-justify"><strong>Syntax :</strong></p>
      <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
      {
         'returntype methodname() {\n'+
         '  //code\n'+
         '  methodname(); //calling same method\n'+
         '}'
      }
      </SyntaxHighlighter>
      <br/>
      <p className="text-align-justify"><strong>Types of Recursion :</strong></p>
      <ul className="text-align-justify">
         <li><strong>Direct Recursion</strong> ~ A function calls itself directly.
            <ul>
               <li><strong>Tail Recursion</strong> ~ The last statement in the function is a recursive call.</li>
               <li><strong>Head Recursion</strong> ~ The recursive call is the first statement in the function.</li>
               <li><strong>Tree Recursion</strong> ~ A recursive function calling itself for more than one time.</li>
               <li><strong>Nested Recursion</strong> ~ &nbsp;A recursive function that passes a recursive call as its parameter.</li>
            </ul>
         </li>
         <li><strong>Indirect Recursion</strong> ~ A function A calls function B and function B calls function A.</li>
      </ul>

      <br/>
      <EmbedYoutube videoType="video" videoList={["HQWyn3Yf33k"]} />

   </div>
</RecursionWrapper>
);

export default Recursion;
